import React from "react";

export const TaskContext = React.createContext({
    filter: {},
    refetch: () => {},
});

export const useTaskContext = () => {
    const context = React.useContext(TaskContext);
    if (!context) {
        throw new Error("useTaskContext must be used within TaskContext");
    }

    return context;
};
